import React from "react";
import { Grid, Typography } from "@mui/material";
import { PostType } from "../../../types";
import { useStyles } from "./Author.styles";

interface AuthorProps {
	post: PostType
}

export function Author({ post }: AuthorProps) {
	const { classes } = useStyles()
	return (
		<section className={classes.root}>
			<Grid container className={classes.container}>
				<Grid item xs={12}>
					<div className={classes.border} />
					<Typography className={classes.title}>
						Artículo por {post?.authorName} {(new Date(post?.publishDate || '').getFullYear() || '')}
					</Typography>
					<div className={classes.border} />
				</Grid>
			</Grid>
		</section>
	)
}